var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadDocumentsBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 416.519,
    height: 409.777,
    viewBox: "0 0 416.519 409.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-1 {\n        opacity: 0.54;\n      }\n\n      .cls-2 {\n        fill: #e6e6e6;\n      }\n\n      .cls-3 {\n        fill: #2f2e41;\n      }\n\n      .cls-4 {\n        fill: #3f3d56;\n      }\n\n      .cls-6 {\n        fill: #f07900;\n      }\n\n      .cls-7 {\n        fill: #ffb8b8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Uploaddocuments-BoardingImage",
    transform: "translate(28.26 140.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    className: "cls-1",
    d: "M150.992,437.164C112.54,424.2,79.19,391.983,72.36,351.983s18.4-85.086,58.039-93.759c18.744-4.1,38.973-.438,56.882-7.324,33.774-12.986,45.251-56.921,76.452-75.243,30.062-17.655,71.279-4.923,93.674,21.8s28.932,63.586,27.557,98.421c-2.017,51.18-23.763,106.378-70.186,128.018-39.12,18.235-121.831,23.4-163.786,13.271",
    transform: "matrix(0.788, 0.616, -0.616, 0.788, 187.893, -316.217)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_199",
    "data-name": "Ellipse 199",
    className: "cls-2",
    cx: 68.34,
    cy: 5.19,
    rx: 68.34,
    ry: 5.19,
    transform: "translate(0 228.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    className: "cls-3",
    d: "M324.272,248.82c11.893-5.059,26.707-1.854,41.173.371.135-2.694,1.766-5.972.057-7.852-2.077-2.283-1.885-4.682-.636-7.1,3.2-6.17-1.383-12.735-6.005-18.194a10.238,10.238,0,0,0-8.545-3.586l-8.563.612a10.255,10.255,0,0,0-9.106,7.33h0c-2.045,2.781-3.139,5.554-2.45,8.313-3.063,2.093-3.577,4.619-2.2,7.467a4.293,4.293,0,0,1-.053,5.236,24.175,24.175,0,0,0-3.594,7.139Z",
    transform: "translate(-272.034 -195.869)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    className: "cls-3",
    d: "M649.028,630.386h-242.4a8.128,8.128,0,0,1-8.128-8.128h0q131.8-15.318,258.656,0h0A8.128,8.128,0,0,1,649.028,630.386Z",
    transform: "translate(-314.156 -424.082)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    className: "cls-4",
    d: "M657.156,406.973,398.5,406.495l29.977-50.44.143-.239V244.651A10.274,10.274,0,0,1,438.9,234.376h176.43A10.274,10.274,0,0,1,625.6,244.652V356.58Z",
    transform: "translate(-314.156 -208.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    className: "cls-5",
    d: "M486.959,250.957a3.35,3.35,0,0,0-3.347,3.347V355.662a3.351,3.351,0,0,0,3.347,3.347H665.293a3.351,3.351,0,0,0,3.347-3.347V254.3a3.351,3.351,0,0,0-3.347-3.347Z",
    transform: "translate(-362.454 -217.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    className: "cls-3",
    d: "M479.078,531.718a1.438,1.438,0,0,0-1.3.835l-9.237,20.08a1.434,1.434,0,0,0,1.3,2.034H664.088a1.434,1.434,0,0,0,1.283-2.076l-10.04-20.081a1.427,1.427,0,0,0-1.282-.793Z",
    transform: "translate(-353.825 -377.051)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    className: "cls-5",
    cx: 2.151,
    cy: 2.151,
    r: 2.151,
    transform: "translate(210.803 27.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    className: "cls-3",
    d: "M646.778,593.619a1.436,1.436,0,0,0-1.385,1.061l-2.317,8.606a1.434,1.434,0,0,0,1.385,1.807h44.064a1.434,1.434,0,0,0,1.355-1.9l-2.979-8.606a1.435,1.435,0,0,0-1.355-.965Z",
    transform: "translate(-452.916 -412.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    className: "cls-3",
    d: "M461.429,337.135v1.912H264.306l.148-.239v-1.673Z",
    transform: "translate(-149.984 -191.312)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_201",
    "data-name": "Ellipse 201",
    className: "cls-6",
    cx: 33.467,
    cy: 33.467,
    r: 33.467,
    transform: "translate(272.479 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    className: "cls-5",
    d: "M904,258.251H876.27a1.914,1.914,0,0,1-1.912-1.912V239.6a1.915,1.915,0,0,1,1.912-1.912H904a1.914,1.914,0,0,1,1.912,1.912v16.734A1.914,1.914,0,0,1,904,258.251ZM876.27,239.6v16.734H904V239.6Z",
    transform: "translate(-584.188 -210.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    className: "cls-5",
    d: "M908.15,219.533H890.938v-7.65c0-5.541,3.619-9.562,8.606-9.562s8.606,4.021,8.606,9.562Zm-15.3-1.912h13.387v-5.737c0-4.5-2.752-7.65-6.693-7.65s-6.693,3.146-6.693,7.65Z",
    transform: "translate(-593.597 -190.129)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    className: "cls-5",
    cx: 1.912,
    cy: 1.912,
    r: 1.912,
    transform: "translate(304.034 35.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    className: "cls-2",
    d: "M672.654,369.734H534.832a2.555,2.555,0,0,1-2.552-2.552V332.994a2.555,2.555,0,0,1,2.552-2.552H672.654a2.555,2.555,0,0,1,2.552,2.552v34.188A2.555,2.555,0,0,1,672.654,369.734ZM534.832,331.462a1.533,1.533,0,0,0-1.531,1.531v34.188a1.533,1.533,0,0,0,1.531,1.531H672.654a1.533,1.533,0,0,0,1.531-1.531V332.994a1.533,1.533,0,0,0-1.531-1.531Z",
    transform: "translate(-390.071 -262.833)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_203",
    "data-name": "Ellipse 203",
    className: "cls-2",
    cx: 10.397,
    cy: 10.397,
    r: 10.397,
    transform: "translate(155.779 75.546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    className: "cls-2",
    d: "M640.93,356.805a1.733,1.733,0,1,0,0,3.466h81.688a1.733,1.733,0,1,0,0-3.466Z",
    transform: "translate(-450.743 -277.794)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    className: "cls-2",
    d: "M640.93,380.842a1.733,1.733,0,1,0,0,3.466h35.15a1.733,1.733,0,1,0,0-3.466Z",
    transform: "translate(-450.743 -291.434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    className: "cls-7",
    d: "M433.173,362.974,407.7,376.52l-.323-11.288a75.454,75.454,0,0,0,23.543-7.74l2.665-6.583a4.463,4.463,0,0,1,7.585-1.158h0a4.463,4.463,0,0,1-.393,6.085Z",
    transform: "translate(-319.191 -272.865)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    className: "cls-3",
    d: "M322.867,540.857h0a5.006,5.006,0,0,1,.636-4.05l5.6-8.589a9.781,9.781,0,0,1,12.688-3.348h0c-2.352,4-2.024,7.516.812,10.568a50.878,50.878,0,0,0-12.083,8.238,5.006,5.006,0,0,1-7.65-2.819Z",
    transform: "translate(-271.136 -372.544)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    className: "cls-3",
    d: "M408.1,487.939h0a9.6,9.6,0,0,1-8.162,4.662l-37.181.282-1.612-9.353,16.448-4.838L363.726,468.05l15.158-17.738,27.531,25.66A9.6,9.6,0,0,1,408.1,487.939Z",
    transform: "translate(-292.958 -330.856)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    className: "cls-3",
    d: "M329.69,518.052h-8.708c-7.818-53.59-15.776-107.33,7.74-127.388l27.735,4.515-3.547,23.543-15.48,17.738Z",
    transform: "translate(-265.695 -297.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    className: "cls-3",
    d: "M345.6,693.032h0a5.006,5.006,0,0,1-4.05-.635l-9.455-1.271a9.781,9.781,0,0,1-3.348-12.688h0c4,2.352,7.516,2.024,10.568-.813,2.157,4.354,5.71,4.089,9.1,7.757a5.006,5.006,0,0,1-2.819,7.65Z",
    transform: "translate(-273.954 -459.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    className: "cls-7",
    d: "M378.016,278.707l-16.125-3.87c2.678-5.482,2.9-11.582,1.612-18.06l10.965-.322A84.208,84.208,0,0,0,378.016,278.707Z",
    transform: "translate(-293.382 -220.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    className: "cls-6",
    d: "M369.807,347.347c-11.738,8-20.032.274-26.362-11.645.88-7.293-.545-16.021-3.182-25.5a17.361,17.361,0,0,1,10.6-20.935h0l13.868,5.805c11.775,9.6,14.093,19.995,9.675,30.96Z",
    transform: "translate(-280.741 -239.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    className: "cls-7",
    d: "M293.356,309.194l-12.9,6.773,22.9,13.545,3.186,7.859a4.168,4.168,0,0,1-2.5,5.507h0a4.168,4.168,0,0,1-5.52-3.7l-.322-5.477-29.1-9.6a6.805,6.805,0,0,1-4.27-4.157h0a6.805,6.805,0,0,1,2.553-7.917l23.4-16.055Z",
    transform: "translate(-238.069 -243.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    className: "cls-6",
    d: "M338.3,306.018c-5.38-2.358-10.272.2-16.448,2.258l-.967-17.093c6.132-3.268,11.978-4.149,17.415-1.612Z",
    transform: "translate(-270.111 -238.806)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    className: "cls-7",
    cx: 10.295,
    cy: 10.295,
    r: 10.295,
    transform: "translate(64.328 23.482)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    className: "cls-3",
    d: "M374.424,237.1c-10.193,1-17.96-.669-22.924-5.415v-3.823h22.059Z",
    transform: "translate(-287.485 -204.625)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDocumentsBanner);
export default __webpack_public_path__ + "static/media/upload-documents-banner.ec1b369d92b162251884410ee3783d38.svg";
export { ForwardRef as ReactComponent };